<script setup lang="ts">
import { computed } from 'vue'

import { useConfigStore } from '../../stores/config'
import { Author } from '../ui/article-meta/Author'
import {
  ArticleMeta,
  AuthorsWrapper,
  AuthorsContent,
  DateWrapper,
  FirstAuthor,
  MiddleAuthors,
  LastAuthor,
  AvatarList
} from '../ui/article-meta'
import DateLocal from '../atoms/DateLocal.vue'

const rsConfig = useConfigStore().rsConfig

const props = withDefaults(
  defineProps<{
    composedAuthors?: Author[]
    displayDate?: string
  }>(),
  {
    composedAuthors: undefined,
    displayDate: ''
  }
)

const firstAuthor = computed(() => {
  return props.composedAuthors?.[0]
})
const lastAuthor = computed(() => {
  return props.composedAuthors && props.composedAuthors.length > 1 ? props.composedAuthors[props.composedAuthors.length - 1] : undefined
})
const middleAuthors = computed(() => {
  return props.composedAuthors?.slice(1, -1) ?? []
})

const hasMiddleAuthors = (middleAuthors?.value?.length ?? 0) > 0

const showTime = computed(() => Boolean(props.displayDate) && rsConfig.updatedArticleDateFormat === 'dateAndTime')

</script>

<template>
  <ArticleMeta :has-middle-authors="hasMiddleAuthors">
    <AuthorsWrapper :has-middle-authors="hasMiddleAuthors">
      <AvatarList :composed-authors="composedAuthors" />
      <AuthorsContent :has-middle-authors="hasMiddleAuthors"
                      :last-author="lastAuthor">
        <template #first-author>
          <FirstAuthor :first-author="firstAuthor"
                       :middle-authors="middleAuthors"
                       :composed-authors="composedAuthors" />
        </template>
        <template #middle-authors>
          <MiddleAuthors :middle-authors="middleAuthors" />
        </template>
        <template #last-author>
          <LastAuthor :last-author="lastAuthor" />
        </template>
      </AuthorsContent>
    </AuthorsWrapper>

    <DateWrapper :has-middle-authors="hasMiddleAuthors"
                 :show-time="showTime">
      <DateLocal v-if="displayDate"
                 :date-time="displayDate"
                 :show-time="showTime" />
    </DateWrapper>
  </ArticleMeta>
</template>
